import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05ffe81c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "relative" };
const _hoisted_2 = { class: "flex justify-between p-[16px] items-center bg-white border border-gray-200 rounded-t-lg border-b-0" };
const _hoisted_3 = { class: "flex items-center gap-6" };
const _hoisted_4 = { class: "text-lg font-semibold text-gray-800" };
const _hoisted_5 = { class: "inline-flex border boreder-gray-300 rounded-md" };
const _hoisted_6 = { class: "flex gap-[16px] items-center" };
const _hoisted_7 = { class: "w-52 toolbar_tab" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "hidden h-0" }, null, -1));
const _hoisted_9 = { class: "flex items-center justify-between min-w-max gap-4" };
const _hoisted_10 = { class: "flex gap-1 items-center text-md" };
const _hoisted_11 = { class: "mr-1" };
const _hoisted_12 = {
    key: 0,
    class: "bg-white border border-gray-300 rounded-lg absolute top-[50px] right-0 z-10 flex flex-col w-full min-w-max text-gray-700 font-semibold text-sm"
};
const _hoisted_13 = { class: "h-8 w-8 flex items-center justify-center rounded-full bg-gray-100" };
const _hoisted_14 = { class: "h-8 w-8 flex items-center justify-center rounded-full bg-gray-100" };
import calendarWidgetStates from '@/helper/calendarWidgetStates';
import { ACTIVE_TAB_SELECTION_FN } from '@/helper/const';
import { CalendarIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, Lightbulb02Icon, PauseCircleIcon, PlusIcon, } from '@gohighlevel/ghl-icons/24/outline/';
import { UIButton, UIDropdown, UITabPane, UITabs, UITooltip, } from '@gohighlevel/ghl-ui';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CalendarAnnotation from './CalendarAnnotation.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolBar',
    props: {
        currentRange: Object,
        handleCustomNavigation: Function,
        toggleView: Function,
        currentDate: String,
        calendarViewMode: String,
        timeZone: String,
        locale: {
            type: String,
            default: 'en_US',
        },
        locationId: String,
        data: null,
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const VIEW_OPTIONS = [
            {
                name: 'timeGridDay',
                title: t('calendarOverlay.day'),
                value: 'timeGridDay',
                tab: 'day',
            },
            {
                name: 'timeGridWeek',
                title: t('calendarOverlay.week'),
                value: 'timeGridWeek',
                tab: 'week',
            },
            {
                name: 'dayGridMonth',
                title: t('calendarOverlay.month'),
                value: 'dayGridMonth',
                tab: 'month',
            },
        ];
        const FILTER_OPTIONS = [
            { label: t('calendarOverlay.all'), key: 'All' },
            {
                label: t('calendarOverlay.appointment'),
                key: 'Appointment',
            },
            { label: t('calendarOverlay.blocked_slot'), key: 'Blocked Slots' },
        ];
        const selectedView = ref({ name: '', tab: '', title: '', value: '' });
        const showCreate = ref(false);
        const wrapperRef = ref(null);
        const showAnnotation = ref(false);
        function handleTabChangeCustom(view) {
            var _a, _b;
            localStorage.setItem(ACTIVE_TAB_SELECTION_FN(props.locationId, (_b = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.loggedInUserInfo) === null || _b === void 0 ? void 0 : _b.id), JSON.stringify(VIEW_OPTIONS.find(item => item.value == view)));
            selectedView.value = VIEW_OPTIONS.find(item => item.value == view);
            props.toggleView(view);
        }
        const headerTitle = computed(() => props.currentDate);
        onMounted(() => {
            var _a, _b;
            const handleClickOutside = event => {
                if (wrapperRef.value && !wrapperRef.value.contains(event.target)) {
                    showCreate.value = false;
                }
            };
            const storedValue = JSON.parse(localStorage.getItem(ACTIVE_TAB_SELECTION_FN(props.locationId, (_b = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.loggedInUserInfo) === null || _b === void 0 ? void 0 : _b.id)));
            if (storedValue &&
                ['timeGridDay', 'timeGridWeek', 'dayGridMonth'].includes(storedValue.value)) {
                selectedView.value = storedValue;
            }
            else {
                selectedView.value = VIEW_OPTIONS[1];
            }
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        });
        const toggleAnnotationModal = () => {
            showAnnotation.value = !showAnnotation.value;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("nav", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_4, _toDisplayString(headerTitle.value), 1)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                                onClick: _cache[0] || (_cache[0] = () => props.handleCustomNavigation('prev')),
                                class: "p-2 border-r border-gray-200"
                            }, [
                                _createVNode(_unref(ChevronLeftIcon), { class: "w-5 h-5" })
                            ]),
                            _createElementVNode("button", {
                                onClick: _cache[1] || (_cache[1] = () => props.handleCustomNavigation('next')),
                                class: "p-2"
                            }, [
                                _createVNode(_unref(ChevronRightIcon), { class: "w-5 h-5" })
                            ])
                        ]),
                        _createVNode(_unref(UIButton), {
                            id: "today",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (props.handleCustomNavigation('today')), ["prevent"])),
                            type: "default"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('calendarOverlay.today')), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(UITooltip), null, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(Lightbulb02Icon), {
                                    class: "w-5 h-5 cursor-pointer focus:outline-none",
                                    onClick: toggleAnnotationModal
                                })
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_unref(t)('calendarOverlay.annotation')), 1)
                            ]),
                            _: 1
                        }),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_unref(UITabs), {
                                type: "segment",
                                "onUpdate:value": _cache[3] || (_cache[3] =
                                    data => {
                                        handleTabChangeCustom(data);
                                    }),
                                "default-value": selectedView.value.name,
                                value: selectedView.value.name
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(VIEW_OPTIONS, (val) => {
                                        return _createVNode(_unref(UITabPane), {
                                            name: val.name,
                                            tab: val.title,
                                            key: val.name
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_8
                                            ]),
                                            _: 2
                                        }, 1032, ["name", "tab"]);
                                    }), 64))
                                ]),
                                _: 1
                            }, 8, ["default-value", "value"])
                        ]),
                        _createVNode(_unref(UIDropdown), {
                            placement: "bottom",
                            options: FILTER_OPTIONS,
                            onSelect: _cache[4] || (_cache[4] = v => (_unref(calendarWidgetStates).filterValue = v)),
                            id: "dropdown",
                            modelValue: _unref(calendarWidgetStates).filterValue,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(calendarWidgetStates).filterValue) = $event))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(UIButton), { id: "btn" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("span", null, _toDisplayString(FILTER_OPTIONS.find(item => item.key === _unref(calendarWidgetStates).filterValue).label), 1),
                                            _createVNode(_unref(ChevronDownIcon), { class: "w-4 h-4" })
                                        ])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", {
                            ref_key: "wrapperRef",
                            ref: wrapperRef,
                            class: "relative w-auto"
                        }, [
                            _createVNode(_unref(UIButton), {
                                id: "bookAppointment",
                                type: "primary",
                                onClick: _cache[6] || (_cache[6] =
                                    () => {
                                        _unref(calendarWidgetStates).bookAppointmentModal.show = true;
                                        showCreate.value = false;
                                    }),
                                class: "px-3"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createVNode(_unref(PlusIcon), { class: "h-4 w-4 text-white" }),
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('calendarOverlay.new')), 1)
                                    ])
                                ]),
                                _: 1
                            }),
                            (showCreate.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("button", {
                                        onClick: _cache[7] || (_cache[7] =
                                            () => {
                                                _unref(calendarWidgetStates).bookAppointmentModal.show = true;
                                                showCreate.value = false;
                                            }),
                                        class: "border-b border-gray-300 py-2.5 px-[16px] w-full flex items-center gap-[10px]"
                                    }, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createVNode(_unref(CalendarIcon), { class: "h-5 w-5" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_unref(t)('calendarOverlay.appointment')), 1)
                                    ]),
                                    _createElementVNode("button", {
                                        class: "border-b border-gray-300 py-2.5 px-[16px] w-full flex items-center gap-[10px]",
                                        onClick: _cache[8] || (_cache[8] =
                                            () => {
                                                _unref(calendarWidgetStates).bookAppointmentModal.show = true;
                                                _unref(calendarWidgetStates).bookAppointmentModal.isBlockedSlot = true;
                                                showCreate.value = false;
                                            })
                                    }, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createVNode(_unref(PauseCircleIcon), { class: "h-5 w-5" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_unref(t)('calendarOverlay.blocked_slot')), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ], 512)
                    ])
                ]),
                _createVNode(CalendarAnnotation, {
                    "show-modal": showAnnotation.value,
                    "on-click-close": toggleAnnotationModal
                }, null, 8, ["show-modal"])
            ]));
        };
    }
});
